import useSWR from 'swr'
import { arcadeApiClient } from '../apiClients'

export interface Entity {
  blockPurchases: boolean
  allowUserProfileUpdates: boolean
  maintenanceMode?: boolean
  // Discrete per-feature kill switches (eng#3763). Each pauses a single flow
  // independently of the broad blockPurchases / maintenanceMode switches.
  disableRewardRedemption?: boolean
  disableTokenTopup?: boolean
  disableTokenTransfers?: boolean
  disableAutoRecharge?: boolean
  name: string
}

const fetcher = async (url: string): Promise<{ entity: Entity }> =>
  await arcadeApiClient.get(url).then(res => res.data)

export const useEntity = () => {
  const { data, mutate } = useSWR('multi_platform/entity', fetcher)
  const entity = data?.entity as Entity
  const isRestricted = entity?.maintenanceMode || entity?.blockPurchases

  return { entity, refetch: mutate, isRestricted }
}
